import { render, staticRenderFns } from "./ClaimsButton.vue?vue&type=template&id=1705147a"
import script from "./ClaimsButton.vue?vue&type=script&lang=ts"
export * from "./ClaimsButton.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsButton.vue?vue&type=style&index=0&id=1705147a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports